import { auth } from "../../firebase";

/**
 * Headers for authenticated API calls: Content-Type + Firebase ID token when signed in.
 * Server middleware verifies the token and loads roles from the database (never trust body.role).
 *
 * Use getApiHeaders() for normal API traffic (guest pages work without a token; protected
 * routes return 401 if unsigned). Use getAuthHeaders() when the caller must be signed in.
 */

/** Content-Type + Bearer when a Firebase user is signed in; Content-Type only otherwise. */
export async function getApiHeaders(extra = {}) {
  const headers = {
    "Content-Type": "application/json",
    ...extra,
  };
  const user = auth.currentUser;
  if (user) {
    const token = await user.getIdToken(true);
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
}

/**
 * Headers for privileged API calls that require a signed-in user.
 * Throws if not signed in.
 */
export async function getAuthHeaders(extra = {}) {
  const user = auth.currentUser;
  if (!user) {
    throw new Error("Not signed in. Please log in again.");
  }
  const token = await user.getIdToken(true);
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    ...extra,
  };
}
